import Vue from 'vue'
import Vuex from 'vuex'
import usuario from './modules/usuario/usuario'
import calendario from './modules/calendario/'
import evaluacion from './modules/evaluacion/'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    login: false
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    usuario,
    calendario,
    evaluacion
  }
})
